<p class="m-0">
  <strong>{{ 'header.search.sectionsTitles.categories' | i18next }}</strong>
</p>

<ng-container *ngIf="suggestions$ | async as suggestions; else noMatches">
  <div class="has-list" *ngFor="let categoryParent of suggestions.categories; last as isLast; trackBy: trackById">
    <shrd-uic-nav-list-button
      *ngFor="let category of categoryParent.children; trackBy: trackById"
      class="subchapter-nav-btn"
      [iconName]="iconsSet.SELECT_ALL"
      [hideIconOnSelect]="false"
      [defaultIconColor]="true"
      [href]="category.id"
      [shrdUtcTrackEvent]="{
        category: 'ProductInfo',
        action: 'FindProducts',
        label: 'SiteSearchAutoSuggest|' + suggestions.term + '|' + category.id
      }"
    >
      <span class="reverse-bold truncate-md-2" [innerHtml]="category.title | highlightText : suggestions.term"></span>
    </shrd-uic-nav-list-button>
    <shrd-uic-nav-list-button
      class="chapter-nav-btn"
      [showIcon]="false"
      [hasTextIndent]="false"
      [href]="categoryParent.id"
      *ngIf="categoryParent.title"
      [shrdUtcTrackEvent]="{
        category: 'ProductInfo',
        action: 'FindProducts',
        label: 'SiteSearchAutoSuggest|' + suggestions.term + '|' + categoryParent.id
      }"
    >
      <span class="truncate-md-2">
        <sub class="compressed-regular">
          {{
            'header.search.matchIn' | i18next : { title: categoryParent.title, interpolation: { escapeValue: false } }
          }}
        </sub>
      </span>
    </shrd-uic-nav-list-button>
    <hr *ngIf="!isLast" shrdUicHr lineHeight="1" />
  </div>
</ng-container>

<ng-template #noMatches>
  <p class="m-0">{{ 'header.search.noMatches' | i18next }}</p>
</ng-template>
